import { Avatar, Grid, TextareaAutosize } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Paper from '@material-ui/core/Paper';
import { Business, FindInPage, Mail, Phone, Room, RoomRounded } from '@material-ui/icons';
import BusinessIcon from '@material-ui/icons/Business';
import { getInfosDashboard, getNumberJobById, acceptABusinessPartner, deleteABusinessPartner, getPartnership, addCommentToPartnership } from '@webapps/business';
import { useAuth, useQuery, useRouter, useMutation, useToast, ModalSideBar } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Partenaire from 'components/Icons/Partenaire';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ConfirmDialog from 'components/ConfirmDialog';
import OfferModalSideBar from './OfferModalSideBar';
import { formatPhoneNumber } from 'react-phone-number-input';

import theme from '../theme';
import ActionsPartner from './ActionsPartner';
import PartnerCardSkeleton from './PartnerCardSkeleton';

const {
  colors: { background },
} = theme;

const PartnerCard = ({ info, refetch, type, accept, isLoading }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { push } = useRouter();
  const { idUser, profile } = useAuth();
  const { addToast } = useToast();

  const [open, setOpen] = useState(false);
  const [commentData, setCommentData] = useState('');
  const [charCount, setCharCount] = useState(0);
  const [openAcceptPartner, setOpenAcceptPartner] = useState(false);
  const [openRejectPartner, setOpenRejectPartner] = useState(false);

  if (isLoading) {
    return <PartnerCardSkeleton />
  }

  const { data: dashboardInfo = {} } = useQuery(getInfosDashboard, {
    key: ['infoDashboardBusiness', info.id],
    variables: { id: info.id },
  });

  const { data: nbr } = useQuery(getNumberJobById, {
    key: ['nbrJobs', info.id],
    variables: { id: info.id },
  });

  const { data: partnership } = useQuery(getPartnership, {
    key: ['partnership', idUser, info.id],
    variables: { schoolId: idUser, businessId: info.id },
  });

  const profileImage = dashboardInfo?.profile?.profileImageUrl || info?.profileImageUrl;

  const goToBusiness = (idBusiness) => {
    push(ROUTES_PATH.BUSINESS_VITRINE, { params: { id: idBusiness } });
  };

  const handleCharacterChange = (event) => {
    const newCharacterCount = event.target.value.length;
    const text = event.target.value;
    if (newCharacterCount <= 200) {
      setCommentData(text);
      setCharCount(newCharacterCount);
    }
  };

  useEffect(() => {
    if (partnership?.schoolComment) {
      setCommentData(partnership.schoolComment);
      setCharCount(partnership.schoolComment.length);
    }
    if (info?.comment) {
      setCommentData(info.comment);
      setCharCount(info.comment.length);
    }
  }, [partnership, info]);

  const {
    isLoading: isLoadingDelete,
    isSuccess: isSuccessDelete,
    mutateAsync: mutateDelete,
  } = useMutation(deleteABusinessPartner);

  const {
    isLoading: isLoadingAccept,
    isSuccess: isSuccessAccept,
    mutateAsync: mutateAccept,
  } = useMutation(acceptABusinessPartner);

  const {
    error,
    isSuccess,
    mutateAsync: mutateComment,
  } = useMutation(addCommentToPartnership);


  const resilePartner = async () => {
    await mutateDelete({
      schoolId: idUser,
      businessId: info.id,
    });
  };

  const handleOnBlur = async () => {
    if (info?.status) {
      await mutateComment({ schoolId: idUser, businessId: info.id, data: { comment: commentData, external: info?.id } })
    } else {
      await mutateComment({ schoolId: idUser, businessId: info.id, data: { comment: commentData, from: profile } })
    }
  }



  const acceptPartner = async () => {
    await mutateAccept({
      schoolId: idUser,
      businessId: info.id,
    });
  };

  useEffect(() => {
    if (isSuccessDelete) {
      addToast({
        status: 'success',
        message: 'Demande rejetée',
      });
      refetch();
      setOpenRejectPartner(false);
    }
  }, [isSuccessDelete]);

  useEffect(() => {
    if (isSuccessAccept) {
      addToast({
        status: 'success',
        message: 'Demande acceptée',
      });
      refetch();
      setOpenAcceptPartner(false);
    }
  }, [isSuccessAccept]);

  useEffect(() => {
    if (error) {
      addToast({
        status: 'error',
        message: 'Erreur pour sauvegarder le commentaire',
      });
    }
    if (isSuccess) {
      addToast({
        status: 'success',
        message: 'Commentaire sauvegarder avec succès',
      });
    }
  }, [error, isSuccess]);

  return (
    <Paper className={classes.cardContainer} elevation={0}>
      <CardContent className={css({ textAlign: 'center', padding: spacing(0, 0, 2.5, 0) })}>
        <div className={css({ display: 'flex', justifyContent: 'space-between' })}>
          <div className={classes.photo}>
            <div>
              {profileImage ? (
                <Avatar className={classes.avatar} src={profileImage} />
              ) : (
                <Avatar className={classes.avatar}>
                  {info.name?.substr(0, 1)}
                </Avatar>
              )}
            </div>
            <Grid>
              <div className={cx(global.title, classes.name)}>
                {info.name} <span className={css({ marginLeft: spacing(1) })}> {info.status == "ongoing" ? null : <VerifiedIcon color={'#1DA1F2'} className={global.smallIcon} />}</span>
              </div>
              <div className={cx(classes.address, global.infoText)}>
                <RoomRounded className={global.smallIcon} /> {info.address?.cityCode} {info.address?.city}
              </div>
            </Grid>
          </div>
          <div>
            <ActionsPartner info={info} refetch={refetch} type={type} accept={accept} setOpen={setOpen} />
          </div>
        </div>
        <div className={cx(global.infoText, classes.infoContainer)}>
          <Partenaire className={classes.iconWidth} />
          <div className={classes.infoText}>{info?.status == "ongoing" ? "Partenaire externe" : "Partenaire interne"}</div>
        </div>
        <div className={cx(global.infoText, classes.infoContainer)}>
          <BusinessIcon className={classes.iconWidth} />
          <div className={[classes.infoText, global.elipsis85]}>{info?.sector ? info.sector.label : 'Non spécifié'}</div>
        </div>
        {!accept && (
          <div className={cx(global.infoText, classes.infoContainer)}>
            <FindInPage className={classes.iconWidth} />
            <div className={classes.infoText}>{nbr} offres d'emploi disponibles</div>
          </div>
        )}
        <div className={cx(global.infoText, classes.infoContainer)}>
          <Mail className={classes.iconWidth} />
          <div className={[classes.infoText, global.elipsis85]}>{accept ? info.email : "Masquée jusqu'à acceptation du partenaire"}</div>
        </div>
        <div className={cx(global.infoText, classes.infoContainer)}>
          <Phone className={classes.iconWidth} />
          <div className={[classes.infoText, global.elipsis85]}>{accept ? info?.phone ? formatPhoneNumber(info?.phone) : 'Non renseigné' : "Masquée jusqu'à acceptation du partenaire"}</div>
        </div>
      </CardContent>
      <div className={classes.buttons}>
        <div style={{ position: 'relative' }}>
          <TextareaAutosize
            maxRows={6}
            value={commentData}
            placeholder="Commentaire : cliquer dans la zone pour écrire"
            className={classes.textArea}
            onChange={handleCharacterChange}
            onBlur={handleOnBlur}
          />
          <p
            style={{
              position: 'absolute',
              bottom: 0,
              right: 15,
              color: '#5D75A8',
            }}
          >
            Caractères : {charCount} / 200
          </p>
        </div>
        {type === "businessToSchool" && !accept && (
          <div className={classes.buttonsContainer}>
            <Button
              fullWidth
              className={css({ backgroundColor: '#C0D9FF' })}
              color="primary"
              variant="outlined"
              disableElevation
              onClick={() => setOpenAcceptPartner(true)}
            >
              Accepter
            </Button>
            <Button
              fullWidth
              className={css({ backgroundColor: '#FBD3D5' })}
              color="secondary"
              variant="outlined"
              disableElevation
              onClick={() => setOpenRejectPartner(true)}
            >
              Refuser
            </Button>
          </div>
        )}
        {info.status != "ongoing" ? (
          <Button
            onClick={() => goToBusiness(info.id)}
            style={{ fontWeight: 600, borderRadius: 10 }}
            variant="outlined"
          >
            <FormattedMessage id="vitrine.btnVoirEtablissement" />
          </Button>
        ) : (
          <Button
            onClick={() => setOpen(true)}
            style={{ fontWeight: 600, borderRadius: 10 }}
            variant="outlined"
          >
            Voir les offres
          </Button>
        )}
      </div>
      <ConfirmDialog
        confirm={() => acceptPartner()}
        handleCloseConfirmDialog={() => setOpenAcceptPartner(false)}
        isLoadingConfirm={isLoadingAccept}
        openConfirm={openAcceptPartner}
        title="Confirmez-vous ?"
      ></ConfirmDialog>
      <ConfirmDialog
        confirm={() => resilePartner()}
        handleCloseConfirmDialog={() => setOpenRejectPartner(false)}
        isLoadingConfirm={isLoadingDelete}
        openConfirm={openRejectPartner}
        title="Confirmez-vous ?"
      ></ConfirmDialog>
      <ModalSideBar
        open={open}
        handleClose={() => setOpen(false)}
        width={1000}
      >
        <OfferModalSideBar info={info} profileImage={profileImage} />
      </ModalSideBar>
    </Paper>
  );
};

PartnerCard.propTypes = {
  id: PropTypes.number,
  specialization: PropTypes.object,
  address: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
  refetch: PropTypes.func,
};

const styles = ({ spacing }) => ({
  container: {
    background,
    borderRadius: 10,
    padding: spacing(2.5),
    marginTop: spacing(3),
  },
  buttonsContainer: {
    display: 'flex',
    columnGap: 10,
  },
  name: {
    marginLeft: spacing(2),
    display: 'flex',
    textAlign: 'start',
    fontFamily: 'Montserrat',
    wordBreak: 'break-all',
  },
  address: {
    display: 'flex',
    marginLeft: spacing(1.5),
    marginTop: spacing(0.5),
    textAlign: 'start',
    alignItems: 'center',
  },
  avatar: {
    height: 60,
    width: 60,
    border: '1px solid #C0D9FF',
  },
  cardContainer: {
    borderRadius: 10,
    padding: spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
  },
  photo: {
    marginBottom: spacing(2),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 'auto',
    rowGap: 10,
  },
  infoContainer: {
    marginTop: spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    textAlign: 'start',
  },
  infoText: {
    wordBreak: 'break-all',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '90%',
  },
  textArea: {
    border: '1px solid #C0D9FF',
    width: '100%',
    resize: 'none',
    color: '#152652',
    borderRadius: '5px',
    minHeight: '128px',
    backgroundColor: '#F3F7FF',
    fontFamily: 'Roboto',
    padding: spacing(2),
    '&:focus': {
      outline: 'none',
    },
    '::placeholder': {
      fontStyle: 'italic',
      fontFamily: 'Roboto',
      color: '#5D75A8',
    },
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
  },
  iconWidth: {
    width: '20px',
    height: '20px',
    marginRight: spacing(1),
  },
});

export default PartnerCard;
